import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import NotificationDropdown from "../Dropdowns/NotificationDropdown";
import UserDropdown from "../Dropdowns/UserDropdown";

const SidebarFinance = () => {
  const navigate = useNavigate();
  const [collapseShow, setCollapseShow] = useState("hidden");
  const [showConfirmBox, setShowConfirmBox] = useState(false);

  const handleLogout = async () => {
    localStorage.removeItem("token");
    toast.success("Logged out Successfully");
    navigate("/auth/login");
  };

  return (
    <>
      <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6">
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
          <ul className="md:hidden items-center flex flex-wrap list-none">
            <li className="inline-block relative">
              <NotificationDropdown />
            </li>
            <li className="inline-block relative">
              <UserDropdown />
            </li>
          </ul>
          <div
            className={
              "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
              collapseShow
            }
          >
            <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200">
              <div className="flex flex-wrap">
                <div className="w-6/12">
                  <Link
                    className="md:block text-left md:pb-2 text-blueGray-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                    to="/"
                  >
                    Notus React
                  </Link>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => setCollapseShow("hidden")}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
            <form className="mt-6 mb-4 md:hidden">
              <div className="mb-3 pt-0">
                <input
                  type="text"
                  placeholder="Search"
                  className="border-0 px-3 py-2 h-12 border border-solid  border-blueGray-500 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-base leading-snug shadow-none outline-none focus:outline-none w-full font-normal"
                />
              </div>
            </form>
            <hr className="my-4 md:min-w-full" />
            <h6 className="md:min-w-full text-blueGray-500 text-xs uppercase font-bold block pt-1 pb-4 no-underline">
              Menu
            </h6>
            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf("/finance/dashboard") !== -1
                      ? "text-lightBlue-600 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/finance/dashboard"
                >
                  <i
                    className={
                      "fas fa-tv mr-2 text-sm text-blueGray-300 " +
                      (window.location.href.indexOf("/finance/dashboard") !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Dashboard
                </Link>
              </li>
              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf(
                      "/finance/vendor-invoices"
                    ) !== -1
                      ? "text-lightBlue-600 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/finance/vendor-invoices"
                >
                  <i
                    className={
                      "fas fa-tv mr-2 text-sm text-blueGray-300 " +
                      (window.location.href.indexOf(
                        "/finance/vendor-invoices"
                      ) !== -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Vendor Invoices
                </Link>
              </li>

              <li className="items-center">
                <Link
                  className={
                    "text-xs uppercase py-3 font-bold block " +
                    (window.location.href.indexOf(
                      "/finance/vendor-bills"
                    ) !== -1
                      ? "text-lightBlue-600 hover:text-lightBlue-600"
                      : "text-blueGray-700 hover:text-blueGray-500")
                  }
                  to="/finance/vendor-bills"
                >
                  <i
                    className={
                      "fas fa-tv mr-2 text-sm text-blueGray-300 " +
                      (window.location.href.indexOf("/finance/vendor-bills") !==
                      -1
                        ? "opacity-75"
                        : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Vendor bills
                </Link>
              </li>

              <li className="items-center">
                <div
                  className="text-xs pl-0.5 uppercase cursor-pointer py-3 font-bold block text-blueGray-700 hover:text-lightBlue-600"
                  onClick={() => {
                    setShowConfirmBox(true);
                  }}
                >
                  <i
                    className={
                      "fas fa-sign-out mr-2 text-sm " +
                      (showConfirmBox ? "opacity-75" : "text-blueGray-300")
                    }
                  ></i>{" "}
                  Log Out
                </div>
              </li>
            </ul>
          </div>
        </div>
        {showConfirmBox && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                padding: "40px",
                borderRadius: "5px",
                textAlign: "center",
              }}
            >
              <p className="mb-4">Are you sure you want to logout?</p>
              <button
                className="bg-gray-300 hover:bg-gray-300 py-1 px-3 rounded ml-2"
                onClick={() => {
                  handleLogout();
                  setShowConfirmBox(false);
                }}
              >
                Yes
              </button>
              <button
                className="bg-gray-300 hover:bg-gray-300 py-1 px-3 rounded ml-2"
                onClick={() => {
                  setShowConfirmBox(false);
                }}
              >
                No
              </button>
            </div>
          </div>
        )}
      </nav>
    </>
  );
};

export default SidebarFinance;
